import React, { useEffect, useState } from 'react'
import { Element } from 'react-scroll'

import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Navigation from '../Navigation/Navigation'
import PageNavigation from '../../components/PageNavigation'
import Appointments from '../Appointments/Appointments'

import './style.css'
import { PriceTableRay } from '../../components/Svg/Icons'
import Preloader from '../../components/Preloader'
import equip_title_bg from '../../assets/img/equip-title.png'
import { ImagePlaceholder } from '../../components/ImagePlaceholder/index'

function Studios(props) {
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const [studiosData, setStudiosData] = useState(null)
  const [isDataLoading, setIsDataLoading] = useState(true)
  const [hasDataError, setHasDataError] = useState(false)
  // eslint-disable-next-line react/prop-types
  const sala = props.match.params.sala
  const studio = studiosData?.[sala]
  const prices = studio?.prices || []

  useEffect(() => {
    let isMounted = true

    const loadStudiosData = async () => {
      try {
        setHasDataError(false)
        setIsDataLoading(true)
        const response = await fetch(`${process.env.PUBLIC_URL}/estudios.json`)
        if (!response.ok) {
          throw new Error('Falha ao carregar estudios.json')
        }
        const data = await response.json()
        if (isMounted) {
          setStudiosData(data)
        }
      } catch (error) {
        if (isMounted) {
          setHasDataError(true)
        }
      } finally {
        if (isMounted) {
          setIsDataLoading(false)
        }
      }
    }

    loadStudiosData()
    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (studio?.color) {
      document.documentElement.style.setProperty('--main-color', studio.color)
    }
  }, [studio])

  if (isDataLoading) {
    return <Preloader />
  }

  return (
    <>
      <div>
        <section id="home" className="Studios">
          <Header />
          <div className="flex-container">
            <Navigation />
            <main>
              <div id="containerStudio" className="flex-container">
                <header className="title">
                  <h3>
                    <span>ESTÚDIOS</span> {`// ${studio?.title || ''}`}
                  </h3>
                  <div className="bigNumber">{studio?.title || ''}</div>
                </header>
                <div className="full-image">
                  {!isImageLoaded && <ImagePlaceholder />}
                  <img
                    className={`img-fluid ${isImageLoaded ? 'd-block' : 'd-none'
                      }`}
                    src={studio?.image}
                    width="1200"
                    height="503"
                    onLoad={() => setIsImageLoaded(true)}
                    alt=""
                  />
                </div>
                <PageNavigation
                  links={['sobre', 'equipamentos', 'marcar']}
                  containers={['home', 'containerStudioInfo', 'containerEquipments', 'containerAppointment']}
                />
              </div>
            </main>
          </div>
        </section>
        <Element name="sobre">
          <section id="containerStudioInfo">
            <div className="titleBackground"></div>
            <div className="row">
              <div className="col l7 s12 flex-container">
                <div className="title">
                  <h4>A {studio?.title}</h4>
                </div>
                <hr></hr>
                <div className="text-container">
                  <div>
                    <p>{studio?.description}</p>
                  </div>
                </div>
                <div className="infoBar">
                  <div className="info">
                    <h4>ESPAÇO</h4>

                    <div className="pill">
                      {studio?.roomsize}m<sup>2</sup>
                    </div>
                  </div>
                  <div className="info">
                    <h4>{studio?.timesTitle}</h4>
                    {(studio?.calendar?.times || []).map((item, index) => (
                      <div key={index} className="pill">
                        {`${item.start}h `}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col l5 s12 studioPriceTable-container">
                <table id="studioPriceTable">
                  <tbody>
                    <tr>
                      <td colSpan={2}>
                        <div className="tableTitle">
                          <PriceTableRay />
                          <h3>PREÇOS</h3>
                          <PriceTableRay className="rayRight" />
                        </div>
                      </td>
                    </tr>
                    {hasDataError && <tr><td className="th2">Erro ao carregar preços.</td></tr>}
                    {!hasDataError && prices.length === 0 && <tr><td className="nopadding"><Preloader /></td></tr>}
                    {prices.map((tablerow, index) => {
                      return (
                        <tr key={index}>
                          {tablerow.col1 ? (
                            <td>{tablerow.col1}</td>
                          ) : (
                            <td className="th2">{tablerow.th}</td>
                          )}
                          <td className="price">{tablerow.col2}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </Element>
        <Element name="equipamentos">
          <section id="containerEquipments">
            <div className="no-container">
              <div className="flex-row flex-center row">
                <div className="col l8 s12 equipmentContainer">
                  {(studio?.equipments || []).map((item, index) => (
                    <div
                      key={index}
                      db_studios-index={index}
                      className={`col s6 ${index % 2 === 0 ? 'top-margin' : ''
                        } `}
                    >
                      <div className="equipmentImg">
                        <div className="bg-title" />
                        <h4>{item.title}</h4>
                        {!isImageLoaded && <ImagePlaceholder />}
                        <img
                          className={`img-fluid ${isImageLoaded ? 'd-block' : 'd-none'
                            }`}
                          src={item.image}
                          width="800"
                          height="800"
                          onLoad={() => setIsImageLoaded(true)}
                          alt=""
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex-center col l4 s12">
                  <div className="equipmentTitle">
                    <div className="titleImg">
                      <img src={`${equip_title_bg}`} alt="" />
                    </div>
                    <h3>EQUIPAMENTOS</h3>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Element>
        <Element name="marcar">
          <Appointments sala={studio || {}} />
        </Element>
        <Footer />
      </div>
    </>
  )
}
export default Studios
